import { createAction } from '@reduxjs/toolkit';

export const setSmartRecommendationPlacements = createAction(
  'insiderTracking/setSmartRecommendationPlacements',
);
export const resetState = createAction('insiderTracking/resetState');
